import { withInstall as o } from "../../utils/with-install.js";
import t from "./checkbox.vue.js";
/* empty css              */
const p = o(t);
export {
  p as ApCheckbox
};
